import { createContext } from 'react';

export const SelectedContext = createContext(null);
export const NavFromContext = createContext();
export const I18NContext = createContext();
